module.exports = {
	"_args": [
		[
			"datalib@1.7.3",
			"/src"
		]
	],
	"_from": "datalib@1.7.3",
	"_id": "datalib@1.7.3",
	"_inBundle": false,
	"_integrity": "sha1-RyJxW7kfWiQRz0K/mEkyzEA+ukg=",
	"_location": "/datalib",
	"_phantomChildren": {},
	"_requested": {
		"type": "version",
		"registry": true,
		"raw": "datalib@1.7.3",
		"name": "datalib",
		"escapedName": "datalib",
		"rawSpec": "1.7.3",
		"saveSpec": null,
		"fetchSpec": "1.7.3"
	},
	"_requiredBy": [
		"/vega",
		"/vega-dataflow",
		"/vega-scenegraph"
	],
	"_resolved": "https://registry.npmjs.org/datalib/-/datalib-1.7.3.tgz",
	"_spec": "1.7.3",
	"_where": "/src",
	"author": {
		"name": "Jeffrey Heer",
		"url": "http://idl.cs.washington.edu"
	},
	"browser": {
		"buffer": false,
		"fs": false,
		"http": false,
		"request": false,
		"sync-request": false,
		"url": false
	},
	"bugs": {
		"url": "https://github.com/vega/datalib/issues"
	},
	"contributors": [
		{
			"name": "Michael Correll",
			"url": "http://pages.cs.wisc.edu/~mcorrell/"
		},
		{
			"name": "Ryan Russell",
			"url": "https://github.com/RussellSprouts"
		}
	],
	"dependencies": {
		"d3-dsv": "0.1",
		"d3-format": "0.4",
		"d3-time": "0.1",
		"d3-time-format": "0.2",
		"request": "^2.67.0",
		"sync-request": "^2.1.0",
		"topojson": "^1.6.19"
	},
	"description": "JavaScript utilites for loading, summarizing and working with data.",
	"devDependencies": {
		"browserify": "^12.0.1",
		"chai": "^3.4.1",
		"istanbul": "latest",
		"jshint": "^2.9.1-rc1",
		"mocha": "^2.3.4",
		"uglify-js": "^2.6.1"
	},
	"homepage": "https://github.com/vega/datalib#readme",
	"keywords": [
		"data",
		"table",
		"statistics",
		"parse",
		"csv",
		"tsv",
		"json",
		"utility"
	],
	"license": "BSD-3-Clause",
	"main": "src/index.js",
	"name": "datalib",
	"repository": {
		"type": "git",
		"url": "git+ssh://git@github.com/vega/datalib.git"
	},
	"scripts": {
		"build": "browserify src/index.js -d -s dl -o datalib.js",
		"cover": "TZ=America/Los_Angeles istanbul cover _mocha -- --recursive test/",
		"deploy": "npm run test && scripts/deploy.sh",
		"lint": "jshint src/",
		"postbuild": "uglifyjs datalib.js -c -m -o datalib.min.js",
		"test": "npm run lint && TZ=America/Los_Angeles mocha --recursive test/"
	},
	"version": "1.7.3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/datalib/package.json
// module id = 1505
// module chunks = 0